import { usePostPortfolioPensionProductsMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioPensionProductsMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { mapPensionCreateFormToRequest } from "web_myplann/Portfolio/Forms/PensionForm/mapPensionFormToRequest";
import { getPensionCreateFormDefaultValues } from "web_myplann/Portfolio/Forms/PensionForm/pensionFormDefaults";
import {
	getPensionCreateFormSchema,
	type PensionCreateFormOutput,
} from "web_myplann/Portfolio/Forms/PensionForm/pensionFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreatePensionForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioPensionProductsMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getPensionCreateFormSchema(t),
		defaultValues: getPensionCreateFormDefaultValues(),
		mutate: (data: PensionCreateFormOutput, options) => {
			mutate(mapPensionCreateFormToRequest(data), options);
		},
		successRoute: Routing.Portfolio.PortfolioAddPensionSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
